import { render } from "./BeautySalonPage.vue?vue&type=template&id=bcde00c6&ts=true"
import script from "./BeautySalonPage.vue?vue&type=script&lang=ts"
export * from "./BeautySalonPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__